module.exports = __webpack_public_path__ + "static/media/serpent-08.931da885.png";